import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  forgottenPasswordRequest,
  forgottenPasswordSuccess,
  forgottenPasswordFailure,
} from '../reducers/login';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/forgottenPassword`;

function* forgottenPasswordFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { Email: email } = state.form.forgottenPassword.values;
  const response = yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        email,
      },
    }),
  );

  return response;
}

function* workerForgottenPasswordSaga() {
  try {
    const response = yield call(forgottenPasswordFunctionAxios);

    const responseFromForgottenPassword = response.data;
    if (response.status === 200) {
      yield put(forgottenPasswordSuccess(responseFromForgottenPassword));
    }

    if (response.status === 205) {
      yield put(forgottenPasswordFailure('Email does not exist'));
    }

    if (response.status === 206) {
      yield put(forgottenPasswordFailure('Login failed'));
    }

    if (response.status === 500) {
      yield put(forgottenPasswordFailure('internal server error'));
    }
  } catch (error) {
    yield put(forgottenPasswordFailure(error));
  }
}

export function* watcherForgottenPasswordSaga() {
  yield takeLatest(forgottenPasswordRequest().type, workerForgottenPasswordSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_forgottenPassword.js